<div class="fill-height p-2">
  <mat-spinner *ngIf="isLoading"></mat-spinner>
  <mat-card>
    <form class="h-100 d-flex flex-column p-2" [formGroup]="form" (submit)="onSaveUser()" *ngIf="!isLoading">
      <mat-form-field>
        <mat-label>Email</mat-label>
        <input matInput type="text" formControlName="email" placeholder="User email">
        <mat-error *ngIf="form.get('email').invalid">Please enter a user email.</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Provider</mat-label>
        <input matInput type="text" formControlName="provider" placeholder="Provider">
        <mat-error *ngIf="form.get('provider').invalid">Please enter a user Provider.</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Language</mat-label>
        <input matInput type="text" formControlName="language" placeholder="Language">
        <mat-error *ngIf="form.get('language').invalid">Please enter a user Language.</mat-error>
      </mat-form-field>
      <mat-form-field>
        <mat-label>Management Branches</mat-label>
        <mat-select formControlName="isBMBranches" multiple>
          <mat-option *ngFor="let branch of branchesNames" [value]="branch">{{ branch }}</mat-option>
        </mat-select>
        <mat-error *ngIf="form.get('isBMBranches').invalid">Please select branches.</mat-error>
      </mat-form-field>
      <mat-checkbox formControlName="isSU">is Super User?</mat-checkbox>
      <button #hiddenSubmitBtn type="submit" style="display: none;"></button>
    </form>
  </mat-card>
</div>

<div class="p-2">
  <div class="d-flex flex-column flex-md-row gap-2">
    <button class="w-100 rounded-pill" mat-raised-button color="primary" type="button" (click)="submitForm()">
      Save User
    </button>
    <button class="w-100 rounded-pill" mat-raised-button color="primary" type="button" (click)="backToUsers()">
      Don't Save Changes
    </button>
    <button class="w-100 rounded-pill" mat-raised-button type="button" (click)="toUsersList()">
      User List
    </button>
  </div>
</div>